import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, SelectInput, EMPTY_ARRAY, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { onChangeOfferValueAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	isActive: yup.boolean(),
	exclSegmentList: yup.string(),
	cashbackRewardPer: yup.number()
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	isActive: yup.boolean(),
	exclSegmentList: yup.string(),
	cashbackRewardPer: yup.number()
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	IS_ACTIVE: 'isActive',
	EXCLUSIVE_SEGMENT_LIST: 'exclSegmentList',
	CASHBACK_REWARD_PERCENTAGE: 'cashbackRewardPer',
	FORM: 'form'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXCLUSIVE_SEGMENT_LIST)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_REWARD_PERCENTAGE)])
	])
];

export const EDIT_TDS_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXCLUSIVE_SEGMENT_LIST)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_REWARD_PERCENTAGE)])
	])
];

const sampleData: { [key: string]: string } = { id: '1', label: 'TEST' };

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [sampleData],
			required: true
		})
		.setToolTip('TDS Segment Name'),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('Is Offer Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is offer active or not'),
	[FORM_FIELD_KEYS.EXCLUSIVE_SEGMENT_LIST]: new RenderConfig()
		.setName('exclSegmentList')
		.setLabel('Segment Exclusive')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		})
		.setToolTip('Is offer limit based or not'),
	[FORM_FIELD_KEYS.CASHBACK_REWARD_PERCENTAGE]: new RenderConfig()
		.setName('cashbackRewardPer')
		.setLabel('TDS Cashback Percentage(%)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeOfferValueAction,
			required: false
		})
};

export const TDS_OFFER_UPDATE_CONFIG = {
	...FORM_FIELD_CONFIG,
	[FORM_FIELD_KEYS.FORM]: new RenderConfig()
		.setName('form')
		.setLabel('Offer form')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
};

export const getFormDefaults = (segmentList: any) => {
	return {
		segmentName: segmentList,
		isActive: true,
		exclSegmentList: '',
		cashbackRewardPer: 0
	};
};
